const BASE_PATH = "app/profile/";

export const SET_PROFILE = `${BASE_PATH}set-profile`;
export const UPDATE_PROFILE = `${BASE_PATH}update-profile`;